var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CorporationM"},[_c('PageContent',[_c('StepsV2',{attrs:{"type":"s4","step":3}}),_c('PanelV2',{attrs:{"type":"w6","title":"You need to open a BDO or BDO Network Bank Account"},on:{"nextClick":_vm.commitData},scopedSlots:_vm._u([{key:"content-solt",fn:function(){return [_c('BdoNoAccount')]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }